import React from "react";
import { connect } from "react-redux";

import IconDelete from "../../../assets/images/icons/trash_g.png";
import IconEdit from "../../../assets/images/icons/edit_g.png";
import IconCar from "../../../assets/images/icons/car_rv.png";

const CarItem = (props) => {
  const { deleteModalCar, editModalCar, car } = props;

  const handleDeleteCar = () => {
    deleteModalCar(car.user_car_id);
  };

  const handleEditCar = () => {
    editModalCar(car.user_car_id);
  };

  return (
    <div className="car_item_box flex">
      <label>
        <img className="hei-15" alt="ماشین" src={IconCar} />
        {car.car?.name.toLowerCase()}
      </label>
      <div className="flex items-center">
        <img
          className="hei-15"
          alt="delete"
          src={IconDelete}
          onClick={handleDeleteCar}
        />
        <img
          className="hei-15 "
          alt="edit"
          src={IconEdit}
          onClick={handleEditCar}
        />
      </div>
    </div>
  );
};

const mstp = (state) => ({
  Login: state.Login,
});
export default connect(mstp)(CarItem);
